import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

export const textColor = "#374151" // Daha modern koyu gri
export const hoverCode="#e0f2fe" // Hafif fintech mavi
export const btnTextColor = "#fff"
export const btnHoverColor = "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)"; // Fintech gradient

export const green = {
  50: '#f0fdf4',
  100: '#dcfce7',
  200: '#bbf7d0',
  300: '#86efac',
  400: '#4ade80',
  500: '#22c55e',
  600: '#16a34a',
  700: '#15803d',
  800: '#166534',
  900: '#14532d',
};

export const blue = {
  0: '#f8fafc',
  25: '#f1f5f9',
  50: '#e2e8f0',
  100: '#cbd5e1',
  150: '#94a3b8',
  200: '#64748b',
  300: '#475569',
  400: '#334155',
  500: '#1e293b',
  600: '#0f172a',
  700: '#1e3c72', // Ana fintech mavi
  800: '#2a5298', // İkincil fintech mavi
  900: '#60a5fa'  // Açık fintech mavi
};

export const grey = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
}

export const primary = {
  lighter: 'rgba(46, 82, 152, 0.08)',
  light: '#60a5fa',
  main: '#2a5298',
  dark: '#1e3c72',
  darker: '#1e293b',
  contrastText: '#FFFFFF',
};

export const secondary = {
  lighter: 'rgba(30, 60, 114, 0.08)',
  light: '#94a3b8',
  main: '#64748b',
  blue: '#1e3c72',
  darker: '#334155',
  contrastText: '#FFFFFF',
  green:'#22c55e'
};

export const info = {
  lighter: '#f0f9ff',
  light: '#7dd3fc',
  main: '#0ea5e9',
  dark: '#0284c7',
  darker: '#0c4a6e',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#f0fdf4',
  light: '#86efac',
  main: '#22c55e',
  dark: '#16a34a',
  darker: '#15803d',
  contrastText: '#FFFFFF',
};

export const warning = {
  lighter: '#fefce8',
  light: '#fde047',
  main: '#eab308',
  dark: '#ca8a04',
  darker: '#a16207',
  contrastText: '#FFFFFF',
};

export const error = {
  lighter: '#fef2f2',
  light: '#fca5a5',
  main: '#ef4444',
  dark: '#dc2626',
  darker: '#b91c1c',
  contrastText: '#FFFFFF',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
  lightGrey: '#F0F0F0'
};

export const action = {
  hover: alpha(hoverCode, 0.9),
  selected: alpha(textColor, 0.16),
  disabled: alpha(textColor, 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.5,
  disabledOpacity: 0.48,
};

export const dashboardAction = {
  hover: alpha('#2a5298', 0.08),
  selected: '#1e3c72',
  disabled: alpha('#64748b', 0.5),
  disabledBackground: alpha('#94a3b8', 0.12),
  focus: alpha('#2a5298', 0.12),
  hoverOpacity: 0.08,
  disabledOpacity: 0.5,
}

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  blue,
  green,
  common,
  divider: alpha(grey[500], 0.2),
  action,
  dashboardAction
};

// ----------------------------------------------------------------------

export function palette() {
  return {
    ...base,
    mode: 'light',
    text: {
      primary: '#374151',
      secondary: '#64748b',
      disabled: '#9ca3af',
      main: '#1f2937',
    },
    background: {
      paper: '#FFFFFF',
      default: '#f8fafc',
      neutral: '#f1f5f9',
    },
    action: {
      ...base.action,
      ...base.dashboardAction,
      active: '#2a5298',
    },
  };
}
